/**
 * Donchian Channel
 *
 * Trend-following channel based on the highest high and lowest low over
 * `period` bars.  Often used to identify breakouts.
 * Upper = highest high, Lower = lowest low, Middle = (Upper + Lower) / 2.
 * Default period: 20.
 *
 * Category: Volatility | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const donchianIndicator: IndicatorDefinition = {
  id: "donchian",
  name: "Donchian Channel",
  shortName: "Donchian",
  category: "volatility",
  pane: "overlay",
  params: [
    { key: "period", label: "Period", type: "number", default: 20, min: 1, max: 500 },
  ],
  plots: [
    { key: "upper", label: "Upper", color: "#42A5F5", style: "line", lineWidth: 1 },
    { key: "middle", label: "Middle", color: "#78909C", style: "line", lineWidth: 1 },
    { key: "lower", label: "Lower", color: "#42A5F5", style: "line", lineWidth: 1 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const upperData: { time: number; value: number }[] = [];
    const middleData: { time: number; value: number }[] = [];
    const lowerData: { time: number; value: number }[] = [];

    for (let i = period - 1; i < candles.length; i++) {
      let high = -Infinity;
      let low = Infinity;
      for (let j = i - period + 1; j <= i; j++) {
        if (candles[j].high > high) high = candles[j].high;
        if (candles[j].low < low) low = candles[j].low;
      }
      upperData.push({ time: candles[i].time, value: high });
      lowerData.push({ time: candles[i].time, value: low });
      middleData.push({ time: candles[i].time, value: (high + low) / 2 });
    }

    return [
      { key: "upper", data: upperData },
      { key: "middle", data: middleData },
      { key: "lower", data: lowerData },
    ];
  },
};
